/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ZzzingServiceType = 'EXTRA_CLEAN' | 'EXTRA_TOWEL' | 'LINEN_CHANGE' | 'BABY_COT' | 'OTHER';

export const ZzzingServiceType = {
    EXTRACLEAN: 'EXTRA_CLEAN' as ZzzingServiceType,
    EXTRATOWEL: 'EXTRA_TOWEL' as ZzzingServiceType,
    LINENCHANGE: 'LINEN_CHANGE' as ZzzingServiceType,
    BABYCOT: 'BABY_COT' as ZzzingServiceType,
    OTHER: 'OTHER' as ZzzingServiceType
};

